<template>
  <div>
    <base-header class="pb-6  bg-gradient-info">
    
	  <div style="min-height:30px;"></div>
      
      
    </base-header>

    <!--start container-->
	  <div class="container-fluid mt--6">
	  
	  <div class="row">
	  	<div class="col-xl-12">
	  		 <base-alert v-if="!verified" type="danger" icon="ni ni-like-2">
          		 <i class="fa fa-exclamation-circle"></i><span  @click="resendVerifyEmail" style="cursor:pointer;"> Please verify your email address. Click to resend the verification email. </span>
            </base-alert>
            
	  		<card style="text-align:center;padding:20px 5px" >
	  			<h2 class="heading " style="font-size:21px;">Appoint Us As Your Company Secretary</h2>
	  		</card>
	  	</div>
	  </div>
	  
	  <div v-if="company.details_form_status==4"  class="row" style="margin-top:50px;margin-bottom:100px;">
			<div class="col-xl-12">
			<card v-if="company.details_form_status==4" gradient="default" style="text-align:center">
				<h4 class="text-white">Thank you for submitting your details and documents. You will be notified once they have been verified.</h4>
			</card>
			</div>
		</div>
			
	  
	  
	    <div v-if="company.details_form_status!=4" class="row"  style="margin:8px 10px" >
     	 <div class="col-xl-12">
      		<card v-if="company.completion_status==4" gradient="default" style="max-width:800px;cursor:pointer;">
      			<div class="row"   @click="toggleCompanyForm()">
      			  <div class="col-md-2">
      			 	 <div style="font-size:32px;text-align:center;" class="btn-inner--icon text-success"><i class="ni ni-check-bold"></i></div>
      			  </div>
      			  <div class="col-md-9" style="">
      			  	<div style="padding-left:10px;padding-right:10px;font-size:14px">
      			 		 <div style="font-size:18px;text-align:center;padding-top:5px;" class="btn-inner--text text-white">Your Company Details </div>
      			 	 </div>
      			 	</div>
      			</div>
      		</card>
      		</div>
      		</div> <!-- end row-->
      		
      		
      		
    	 <div class="row" v-if="showCompanyForm">
     	 <div class="col-xl-12">
     		<card>
     		  <validation-observer v-slot="{handleSubmit}" ref="formValidator">
				   <form class="needs-validation"
				   @submit.prevent="handleSubmit(confirmCompany)"
				   				>
     		
     				 <div class="row" style="margin-top:10px;padding-left:15px;">
						 <div class="col-xl-6">
							 <h3 style="font-size:20px;">Company Details</h3>	
						 </div>
					 </div>
					 
					 
      				<card>
    				  <div class="row">
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		<base-input disabled label="Your Company Name"   :rules="{required: true}" name="company name" v-model="company.entity_name">
					  		  
					  		</base-input>
					 	</div>
					 	 <div class="col-xl-3" style="margin-top:20px;"> 
					  		<base-input label="Financial Year-End" :rules="{required: true}" name="financial year-end" >
								<flat-picker slot-scope="{focus, blur}"
											 @on-open="focus"
											 @on-close="blur"
											 :config="{allowInput: true}"
											 class="form-control datepicker"
											 v-model="company.date_fye">
								</flat-picker>
                     		 </base-input>
					 	</div>
					 	
					 	
					  </div> <!-- end row -->
					  
					  
					    <div class="row">
					 	 <div class="col-xl-4" style="margin-top:20px;"> 
					  		<base-input  label="UEN" disabled   :rules="{required: true}" name="uen" v-model="company.uen">
					  		  
					  		</base-input>
					 	</div>
					 	
					 	
					 	
					  </div> <!-- end row -->
					  
					  
					   <div class="row">
					 	 <div class="col-xl-5" style="margin-top:20px;"> 
					 	 
					 	  <label class="form-control-label">SSIC Code Of Primary Business Activity</label>  &nbsp;
					 	  <el-tooltip content="Singapore Standard Industrial Classification (SSIC)" placement="top">
					 		  <i class="fa fa-info-circle "/>
					 	   </el-tooltip>
					 	   
					 	 	<vue-bootstrap-typeahead
								class="mb-4"
								v-model="query"
								:data="ssiccodes"
								:serializer="item => item.title_and_code"
								@hit="ssic_info_1 = $event"
								placeholder="Search by describing your business"
							  />
							  
							  
					</div>
					 	 <div class="col-xl-2" style="margin-top:20px;"> 
					 	 
					 	 <base-input label="Selected SSIC Code" :rules="{required: true}" name="primary activity's SSIC code" disabled v-model="ssic_info_1.code"/>
							
					 	 

					 	</div>
					 	 <div class="col-xl-5" style="margin-top:20px;"> 
							
							<base-input label="Selected SSIC Title"  disabled v-model="ssic_info_1.title"/>
					 	</div>
					 	
					 	
					  </div> <!-- end row -->
					  
					  
					  <div class="row">
					 	 <div class="col-xl-10" style="margin-top:20px;"> 
					 	 
					 	  <base-input label=" Description Of Primary Business Activity"
     						    :rules="{required: true}" name="primary activity's description"
     						  >
					  		 <textarea class="form-control" id=""
					  			
					  		  v-model="company.activity_1_desc" placeholder="Describe you business in more detail" rows="3"></textarea>
					  		   </base-input>
					 	 
					 	 
					 	 </div>
					  
					</div> <!-- end row -->
					
					
					   <div class="row" style="margin-top:50px;">
					 	 <div class="col-xl-5" style="margin-top:20px;"> 
					 	 
					 	  <label class="form-control-label">SSIC Code Of Secondary Business Activity</label>  &nbsp;
					 	  <el-tooltip content="Singapore Standard Industrial Classification (SSIC)" placement="top">
					 		  <i class="fa fa-info-circle "/>
					 	   </el-tooltip>
					 	   
					 	 	<vue-bootstrap-typeahead
								class="mb-4"
								v-model="query"
								:data="ssiccodes"
								:serializer="item => item.title_and_code"
								@hit="ssic_info_2 = $event"
								placeholder="Search by describing your business"
							  />
							  
							  
					</div>
					 	 <div class="col-xl-2" style="margin-top:20px;"> 
					 	 
					 	 <base-input label="Selected SSIC Code" placeholder="Optional" name="secondary activity's SSIC code" disabled v-model="ssic_info_2.code"/>
							
					 	 

					 	</div>
					 	 <div class="col-xl-5" style="margin-top:20px;"> 
							
							<base-input label="Selected SSIC Title" placeholder="Optional"  disabled v-model="ssic_info_2.title"/>
					 	</div>
					 	
					 	
					  </div> <!-- end row -->
					  
					  
					  <div class="row">
					 	 <div class="col-xl-10" style="margin-top:20px;"> 
					 	 
					 	  <base-input label=" Description Of Secondary Business Activity"
     						    name="secondary activity's description"
     						  >
					  		 <textarea class="form-control" id=""
					  			
					  		  v-model="company.activity_2_desc" placeholder="Optional" rows="3"></textarea>
					  		   </base-input>
					 	 
					 	 
					 	 </div>
					  
					</div> <!-- end row -->
					    
					    
					    
					 

     				</card> <!-- end company details -->
     				
     				
     			     <div class="row" style="margin-top:80px;padding-left:15px;">
						 <div class="col-xl-6">
							 <h3 style="font-size:20px;">Registered Company Address (Singapore)</h3>	
						 </div>
					 </div>
					 
						 
					 
      				<card  >
      				  <div class="row">
					 	 <div class="col-xl-5" style="margin-top:20px;"> 
					  		<base-input  label="Address Line 1"  :rules="{required: true}" name="address line 1" v-model="company.address_1"/>
					 	</div>
					 	<div class="col-xl-5" style="margin-top:20px;"> 
					 		<base-input  label="Address Line 2"  name="address line 2" v-model="company.address_2"/>
					 	</div>
					 		
					 	<div class="col-xl-2" style="margin-top:20px;"> 
					 		<base-input  label="Postal Code"   :rules="{required: true}" name="postal code" v-model="company.zipcode"/>
					 	</div>
					 	
					 	
					  </div> <!-- end row -->
					  
					  <div class="row">
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		<base-input  label="Address Of Principal Place Of Business (if different from above)" 
					  		placeholder="optional" name="address line 1" v-model="company.address_main_biz"/>
					 	</div>
	
					 	
					 	
					  </div> <!-- end row -->
					  
					  
      					
      				</card><!-- end company adddress -->
     			
     			
     			
     			 <div class="row" style="margin-top:80px;padding-left:15px;">
						 <div class="col-xl-6">
							 <h3 style="font-size:20px;">Shareholding</h3>	
						 </div>
				</div>
				<card>
					 <div class="row">
					 	 <div class="col-xl-5" style="margin-top:20px;"> 
					  		<base-input  label="Total Issued Shares"  :rules="{required: true}" name="total shares" v-model="company.total_shares">
					  		 <small slot="append" class="font-weight-bold">Ordinary Shares</small>
					  		</base-input>
					 	</div>
					 	<div class="col-xl-5" style="margin-top:20px;"> 
					 		<base-input  label="Total Paid-up Capital"  :rules="{required: true}" name="total paid-up capital" v-model="company.total_paid_up_capital">
					  		 <small slot="append" class="font-weight-bold">SGD</small>
					  		</base-input>
					 	</div>
					 		
					 	<div class="col-xl-2" style="margin-top:20px;"> 
					 	</div>
					 	
					 	
					  </div> <!-- end row -->
				
				
				</card><!-- end company shareholding -->
				
				
				
     			 <div class="row" style="margin-top:80px;padding-left:15px;">
						 <div class="col-xl-6">
							 <h3 style="font-size:20px;">Additional Details</h3>	
						 </div>
				</div>
				<card>
					 <div class="row">
					 	 <div class="col-xl-5" style="margin-top:20px;"> 
					  			<label class="form-control-label">
        						Source Of Funds For Running This Company
     						 </label> 
     						 <span class="text-warning" style="font-size:10px;"> * Select at least one</span>
							<br/><br/>
							 
								 <input type="checkbox" v-model="company.sources_arr" value="personal_savings" id="personal_savings" class="mb-3" style="margin-right:11px;">
									<label for="personal_savings" style="font-size:15px;"> Personal Savings</label> <br/>
									
							  	
							  	 <input type="checkbox" v-model="company.sources_arr" value="loans_family" id="loan_family" class="mb-3" style="margin-right:11px;">
									<label for="loan_family" style="font-size:15px;"> Loans (friends and family)</label><br/>
										

							  	 <input type="checkbox" v-model="company.sources_arr" value="loans_bank" id="loan_bank" class="mb-3" style="margin-right:11px;">
							  	 	<label for="loan_bank" style="font-size:15px;"> Loans (banks and other financial institutions)</label>	<br/>
							  
							  <input type="checkbox" v-model="company.sources_arr" value="inheritance" id="inheritance"  class="mb-3"  style="margin-right:11px;">
										<label for="inheritance" style="font-size:15px;">Inheritance </label>	<br/>
										
							  	 <input type="checkbox" v-model="company.sources_arr" value="investors" id="investors" class="mb-3" style="margin-right:11px;">
									<label for="investors" style="font-size:15px;">	Investors</label>	<br/>
									
							  	 <input type="checkbox" v-model="company.sources_arr" value="profit_investment" id="profit_investment" class="mb-3"  style="margin-right:11px;">
									<label for="profit_investment" style="font-size:15px;">	Profits From Investments Or Businesses</label>	<br/>
									
									
					 	</div>
					  </div> <!-- end row -->
				
				
				</card><!-- end company additional info -->
				
				
				
				
				
				
				
				
				  <div style="min-height:70px;"></div>
				
				 <base-button block type="primary" native-type="submit" style="padding-top:20px;padding-bottom:20px;">Confirm Company Details</base-button>
					
			     <div style="min-height:70px;"></div>
     		 		</form>
				</validation-observer>	  
     	
     	</card>
     
     	</div>
     </div>
    
    
      
      <div v-if="company.details_form_status!=4"  class="row" v-for="(d, index) in people"  :key="'d'+index" style="margin:0px 10px">
     	 <div class="col-xl-12">
      		<card v-if="d.completion_status==4" type="default" style="max-width:800px;cursor:pointer;">
      			<div class="row"  @click="displayPersonForm(index)">
      			  <div class="col-md-2">
      			 	 <div style="font-size:32px;text-align:center;" class="btn-inner--icon text-success"><i class="ni ni-check-bold"></i></div>
      			  </div>
      			  <div class="col-md-9" style="">
      			  	<div style="padding-left:10px;padding-right:10px;font-size:14px">
      			 		 <div style="font-size:18px;text-align:center;" class="btn-inner--text text-white"> {{d.first_name}} {{d.last_name}} </div>
      			 		 <div v-if="d.is_shareholder==1 && d.is_director==1" style="text-align:center;" class="btn-inner--text text-white">Director And Shareholder</div>
      			 		 <div v-else-if="d.is_director==1" style="text-align:center;" class="btn-inner--text text-white">Director</div>
      			 		 <div v-else-if="d.is_shareholder==1" style="text-align:center;" class="btn-inner--text text-white">Shareholder</div>
      			 		  <div v-else style="text-align:center;" class="btn-inner--text text-white">Contact Person/Agent</div>
      			 	 </div>
      			 	</div>
      			</div>
      		</card>
      		
      		<card v-if="!d.completion_status"  style="max-width:800px;cursor:pointer;">
      			<div class="row"  @click="displayPersonForm(index)">
      			  <div class="col-md-2">
      			 	 <div style="font-size:32px;text-align:center;" class="btn-inner--icon text-danger"><i class="fa fa-edit"></i></div>
      			  </div>
      			  <div class="col-md-9" style="">
      			  	<div style="padding-left:10px;padding-right:10px;font-size:14px">
      			 		 <div style="font-size:18px;text-align:center;" class="btn-inner--text "> {{d.first_name}} {{d.last_name}} </div>
      			 		 <div v-if="d.is_shareholder==1 && d.is_director==1" style="text-align:center;" class="btn-inner--text ">Director And Shareholder</div>
      			 		 <div v-else-if="d.is_director==1" style="text-align:center;" class="btn-inner--text ">Director</div>
      			 		 <div v-else-if="d.is_shareholder==1" style="text-align:center;" class="btn-inner--text ">Shareholder</div>
      			 		 <div v-else style="text-align:center;" class="btn-inner--text ">Contact Person/Agent</div>
      			 	 </div>
      			 	</div>
      			</div>
      		</card>
      		<!-- end header-->
      		 <card v-if="displayPerson == index">
      		 
      		   <validation-observer v-slot="{handleSubmit}" ref="formValidator">
				   <form class="needs-validation"
				   @submit.prevent="handleSubmit(confirmPerson)"
				   				>
      		 
      		 		 <div class="row" style="margin-top:40px;padding-left:15px;">
						 <div class="col-xl-6">
							 <h3 style="font-size:20px;">General Information</h3>	
						 </div>
					 </div>
					 
					 
      				<card>
    				  <div class="row">
					 	 <div class="col-xl-5" style="margin-top:20px;"> 
					  		<base-input prepend-icon="fas fa-user" label="First Name"   :rules="{required: true}" name="first name" v-model="d.first_name"/>
					 	</div>
					 	 <div class="col-xl-5" style="margin-top:20px;"> 
					  		<base-input label="Last Name"  v-model="d.last_name"/>
					 	</div>
					 	 <div class="col-xl-2" style="margin-top:20px;"> 
					 	 	 <base-input  label="Gender" :rules="{required: true}" name="gender">
							  <el-select v-model="d.gender" 
										 placeholder="Select">
								<el-option v-for="option in selects.gender"
										   :key="option.label"
										   :label="option.label"
										   :value="option.value">
								</el-option>
							  </el-select>
							</base-input>
					 	</div>
					 	
					  </div> <!-- end row -->
				
				
					<div class="row">
					 	 <div class="col-xl-3" style="margin-top:20px;"> 
					  		<base-input  prepend-icon="fas fa-phone" label="Contact Number" :rules="{required: true}" name="contact number"  v-model="d.contact_number"/>
					 	</div>
					 	 <div class="col-xl-4" style="margin-top:20px;"> 
					 	 <base-input  prepend-icon="fas fa-envelope" label="Email Address" :rules="{required: true, email:true}" name="email"  v-model="d.email"/>
					 	</div>
					 	
					 	 <div class="col-xl-4" style="margin-top:20px;"> 
					 	 
					 	 	<base-input label="Date Of Birth" :rules="{required: true}" name="date of birth" >
                        <flat-picker slot-scope="{focus, blur}"
                                     @on-open="focus"
                                     @on-close="blur"
                                     :config="{allowInput: true}"
                                     class="form-control datepicker"
                                     v-model="d.dob">
                        </flat-picker>
                      </base-input>
					 	 </div>
					  </div> <!-- end row -->
					  
					  
					<div class="row">
					 	 <div class="col-xl-4" style="margin-top:20px;"> 
					  		<base-input label="NRIC / FIN / ID Number" :rules="{required: true}" name="identification number"   v-model="d.gov_id"/>
					 	</div>
					 	 <div class="col-xl-4" style="margin-top:20px;"> 
					  		 <base-input label="ID Type"   name="ID Type" :rules="{required: true}">
							  <el-select v-model="d.gov_id_type" 
										 placeholder="Please select an option">
								<el-option v-for="option in selects.gov_id_types"
										   :key="option.label"
										   :label="option.label"
										   :value="option.value">
								</el-option>
							  </el-select>
							</base-input>
					 	</div>
					 	
					 	<div class="col-xl-4" style="margin-top:20px;">
					  		 <base-input  label="Nationality" :rules="{required: true}" name="nationality">
							  <el-select v-model="d.nationality" filterable
										 placeholder="Select Your Country">
								<el-option v-for="option in countries"
										   :key="option.label"
										   :label="option.label"
										   :value="option.value">
								</el-option>
							  </el-select>
							</base-input>
					 	
					 	</div>
					 	
					  </div> <!-- end row -->
					  
					  
					  <div class="row">
					 	 <div class="col-xl-4" style="margin-top:20px;"> 
						 <base-input  label="Citizenship" :rules="{required: true}" name="citizenship">
							  <el-select v-model="d.citizenship" filterable
										 placeholder="Select">
								<el-option v-for="option in selects.citizenship"
										   :key="option.label"
										   :label="option.label"
										   :value="option.value">
								</el-option>
							  </el-select>
							</base-input>

					 	</div>
					 	 <div class="col-xl-4" style="margin-top:20px;"> 
					  	
					 	</div>
					 	
					 	<div class="col-xl-4" style="margin-top:20px;">
					  		
					 	
					 	</div>
					 	
					  </div> <!-- end row -->
					  
					  </card>
					  
					<div class="row">
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		 
					 	</div>
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		
					 	</div>
					  </div> <!-- end row -->
					  
					  
					  
					   <div class="row" style="margin-top:40px;padding-left:15px;">
						 <div class="col-xl-6">
							 <h3 style="font-size:20px;">Residential Address</h3>	
						 </div>
					 </div>
					 
					 
      				<card>
    				  <div class="row">
    				  	 <div class="col-xl-6" style="margin-top:20px;"> 
							<base-input  prepend-icon="fas fa-map-marker" label="Address Line 1"   :rules="{required: true}" name="address line 1" v-model="d.address_1"/>

					 	</div>
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
				     		 <base-input label="Address Line 2"  placeholder="optional"  name="address line 2" v-model="d.address_2"/>
		
					 	</div>
    				  
    				  </div> <!-- end row -->
    				  
    				  
    				   <div class="row">
    				  	 <div class="col-xl-4" style="margin-top:20px;"> 
							<base-input  label="City"  placeholder="optional" name="city" v-model="d.city"/>

					 	</div>
					 	<div class="col-xl-4" style="margin-top:20px;"> 
							<base-input  label="Province" placeholder="optional"  name="province" v-model="d.province"/>

					 	</div>
					 	 <div class="col-xl-3" style="margin-top:20px;"> 
				     		 <base-input label="Postal Code"  :rules="{required: true}" name="postal code" v-model="d.zipcode"/>
		
					 	</div>
    				  
    				  </div> <!-- end row -->
    				  
    				  
    				  <div class="row">
    				  	 <div class="col-xl-4" style="margin-top:20px;"> 
				     		  
    				   <base-input  label="Country Of Residence" name="country of residence" :rules="{required: true}">
							  <el-select v-model="d.address_country" filterable
										 placeholder="Select">
								<el-option v-for="option in countries"
										   :key="option.label"
										   :label="option.label"
										   :value="option.value">
								</el-option>
							  </el-select>
							</base-input>

					 	</div>
					 	<div class="col-xl-4" style="margin-top:20px;"> 

					 	</div>
					 	 <div class="col-xl-3" style="margin-top:20px;"> 
		
					 	</div>
    				  
    				  </div> <!-- end row -->
    			    				</card> <!-- end address card -->

    				  
    			 <div class="row" v-if="d.is_shareholder==1" style="margin-top:120px;padding-left:15px;">
						 <div class="col-xl-6">
							 <h3 style="font-size:20px;">Shareholding</h3>	
						 </div>
					 </div>
					 
					 
      			<card  v-if="d.is_shareholder==1" >
      				 <div class="row">
    				  	 <div class="col-xl-4" style="margin-top:20px;"> 
							<base-input  label="Number Of Shares"  name="number of shares" v-model="d.num_shares" :rules="{required: true}">
							 <small slot="append" class="font-weight-bold">Ordinary Shares</small>
							</base-input>
    				
					 	</div>
					 	<div class="col-xl-4" style="margin-top:20px;"> 
							<base-input  label="Paid-up Capital"   name="paid-up capital" v-model="d.paid_up_capital" :rules="{required: true}">
							 <small slot="append" class="font-weight-bold">SGD</small>
							</base-input>

					 	</div>
					 	 <div class="col-xl-3" style="margin-top:20px;"> 
		
					 	</div>
    				  
    				  </div> <!-- end row -->
    			</card> <!-- end: shareholding information-->
      				
    			
    			
    			
    	     <div class="row"  style="margin-top:120px;padding-left:15px;">
						 <div class="col-xl-6">
							 <h3 style="font-size:20px;">Politically Exposed Person (PEP) Declaration</h3>	
						 </div>
					 </div>
				<card type="default" class="text-white">
				A PEP is a person: <br/><br/>
					<ul>
						<li> Who is or has been entrusted with any prominent public function in Singapore, a country or territory outside Singapore, or by an international organization at present; or
						<br/><br/>
						</li>
						<li> Who previously meets the first criteria but has stepped down from his prominent public function.
						<br/><br/>
						</li>
						<li> Who is an immediate family member or a close associate of a person that meets the first 2 criteria.
						<br/><br/>
						</li>
					</ul>
				
				</card>		 
					 
      			<card  >
    			<div class="row">
    				  	 <div class="col-xl-6" style="margin-top:20px;"> 
							 <base-input label="Is this person or any party closely connected to this person a PEP?" name="PEP" :rules="{required: true}">
							  <el-select v-model="d.has_pep" 
										 placeholder="Select">
								<el-option v-for="option in selects.yesno"
										   :key="option.label"
										   :label="option.label"
										   :value="option.value">
								</el-option>
							  </el-select>
							</base-input>
    				
					 	</div>
					 	<div class="col-xl-6" style="margin-top:20px;"> 
							

					 	</div>
					 	
    				  
    				  </div> <!-- end row -->
    				  
    					<div v-if="d.has_pep==1" class="row">
    				  	 <div class="col-xl-12" style="margin-top:20px;"> 
    				  	 	<div>
    				  	 	 If yes, please tell us about the following:
    				  	 	 <br/><br/>
    				  	 	 <ul>
    				  	 	 	<li>Name of PEP (if this director/shareholder isn't the PEP)</li>
    				  	 	 	<li>Country which PEP holds prominent public function</li>
    				  	 	 	<li>Nature of the prominent public function</li>
    				  	 	 	<li>Period of time in which person was a PEP</li>
    				  	 	    <li>PEP's relationship with this director/shareholder(if applicable)</li>
    				  	 	    <li>This director/shareholder's source of wealth</li>
    				  	 	     <li>This director/shareholder's source of funds for the new company (if applicable)</li>
    				  	 	 </ul>
    				  	 
    				  	 	</div>
    				  	 		 <br/><br/>
							 	<base-input >
                   					 <textarea class="form-control" v-model="d.pep_description" rows="6"></textarea>
                  				</base-input>	
					 	</div>
		
    				  
    				  </div> <!-- end row -->
    			
    			</card> <!-- end: pep information-->
    		
    	
    		
    		
    				  
    				  
					  
					 <base-button block type="primary" native-type="submit">Confirm Details For This Person</base-button>
					
					  <div style="min-height:150px;"></div>
					  
				 </form>
				</validation-observer>	  
			</card>
      		
      		
      			
      		</div>
        </div><!-- end foreach person-->
      
 	<div class="row">
       <div class="col-xl-6"><!-- start left column -->
      		<div style="margin-top:30px;"><h1>Upload Supporting Documents</h1></div>
      		
      		
      		<div class="row " style="">
      		<div class="col-xl-10">
      		
      		<card type="default" class="text-white">
						For each person above, please upload the following:  <br/><br/>
						<ul>
						<li><span class="text-warning" style="font-weight:bold;">Singapore Citizens</span> <br/>- Copy of Singapore IC (front and back) <br/><br/>
						
						</li>
						<li><span class="text-warning" style="font-weight:bold;">Singapore PRs</span> <br/> - Copy of Singapore IC (front and back) <br/> - Copy of foreign passport (personal particulars page)  <br/><br/></li>
						<li><span class="text-warning" style="font-weight:bold;">Singapore Employment Pass Holders</span>
							 <br/> - Copy of FIN (front and back)
							 <br/> - Copy of foreign passport (personal particulars page) 
							 <br/> -  Proof of residency (i.e., tenancy agreement, utility bill, bank statement)  <br/><br/> 
						</li>
						<li><span class="text-warning" style="font-weight:bold;">Non-residents</span>
							 <br/> - Copy of passport (personal particulars page)
							 <br/> - Proof of overseas residential address (i.e., tenancy agreement, utility bill, bank statement)
							  <br/><br/> 
						</li>	
						
						</ul>
 					
 					</card>
 					
 					
 					
 					
 					<card v-if="!company.own_local_director" type="default" class="text-white">
						If you are using our nominee director service, please upload a bank reference letter.  <br/><br/>
					</card>
					
      			</div>
      		</div><!-- end row -->
      		<div style="min-height:50px;"></div>

      		<!-- start: documents -->
				<div class="row " style="">
					
 					
 					
 					
 
 					
 					
 					<!-- start -->
					  <div v-for="d in documents" class="col-md-auto" @click="viewReqDoc(d.id)" :key="d.id">
					   <card  >
						  <div class="row align-items-center">
							<div class="col-auto">			  
							   <div class="icon icon-shape text-white rounded-circle shadow bg-warning">
									<i class="fa fa-file-alt"></i>
								</div>
							</div>
							<div class="col ml--2">
							  <h4 class="mb-0">
								{{d.document_name}}
							  </h4>

							</div>
							<div class="col-auto">
							</div>
						  </div>
						</card>
						</div>
 					<!-- end -->
 					
 				
 					
 					
 					
				</div><!-- end documents row -->
				
				<!-- start upload doc -->
				<div class="row">
					
 					<div class="col-md-auto">
 						<card>
 							<form style="padding-bottom:20px;">
 								<input type="file" id="file" ref="new_file" class="btn btn-default" />
 							</form>
 							 <base-button block type="primary" @click.prevent="uploadFile">Upload File</base-button>
 						</card>
 					</div>
 					
				</div>
				<!-- end upload doc -->
				
				
		<div class="row" style="margin-top:50px;margin-bottom:100px;">
			<div class="col-xl-12">
			<card v-if="company.details_form_status==4" gradient="default" style="text-align:center">
				<h4 class="text-white">Thank you for submitting your details and documents. You will be notified once they have been verified.</h4>
			</card>
			
			<card gradient="warning" v-else>
			<div style="width:100%;text-align:center;margin-bottom:20px;"><i class="ni ni-spaceship text-white" style="font-size:32px"></i></div>
			 <base-button block type="success" @click.prevent="confirmCompletion" style="padding:30px 60px;font-size:17px">
			 		Click to confirm you have completed all details and uploaded all required supporting documents
			 
			 </base-button>
			 </card>
			 
			 
			</div>
		</div>

		</div> <!-- end left column -->
		
		  <div class="col-xl-6"> <!-- start right column -->
		  		
		  		<div style="margin-top:30px;"><h1>Messages</h1></div>
      	
				<!-- start: send message -->
				<div class="row " style="padding-bottom:40px;">
					<div class="col-xl-11">
					<div class="card">
						<div class="card-body" style="min-height:150px;">
							 <form>
						  <base-input>
							<textarea placeholder="Send a message to your company secretary." class="form-control" v-model="new_message.message" rows="3"></textarea>
						  </base-input>
						</form>
						 <base-button block type="primary" @click.prevent="submitCreateMessage">Send</base-button>
				
				
						</div>
					</div>
					</div><!-- end column -->
			
				 </div>
				 <!-- end: send message -->
		
		
		
				<!-- start: messages -->
				<div class="row ">
					<div class="col-xl-11" v-for="m in messages" :key="m.id">
					<card class="">
						 <!-- Card header -->
						<div slot="header" class="row align-items-center " style="padding:0px;">
						  <div class="col-8">
							<!-- Title -->
							 <base-button v-if="m.is_client==1" icon type="warning">
								<span class="btn-inner--icon"><i class="fa fa-user-tie"></i></span>
							  </base-button>
							  
							   <base-button v-if="m.is_client==2" icon type="default">
								<span class="btn-inner--icon"><i class="ni ni-badge"></i></span>
							  </base-button>
							  
							  
							<span class="h5"> 
								<span v-if="m.is_client==1"> Me </span>
								<span v-if="m.is_client==2"> Secretary</span>
							</span>
						  </div>
						  <div class="col-4 text-right">
							<span class="h5">{{m.created_at_str}}</span>
						  </div>
						</div>
						
						<div class="card-text" style="min-height:90px;">
						<span style="white-space: pre;">	{{m.message}} </span>
						</div>
						
					</card>
					</div><!-- end column -->
			
				 </div>
				 <!-- end: messages -->
		  </div><!-- end right column -->
	</div><!-- end 2nd row -->

      
     


    </div>  <!--End container-->
    
    
    
    
    
    
  <!--start container-->
    <div class="container-fluid mt--6">
      <div class="row">
     
    </div>
    </div>  <!--End container-->
    
    
    
    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>

  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';
  import { Select, Option } from 'element-ui';
   import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  
  
   import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'

  export default {
    components: {
    	 [Select.name]: Select,
     	 [Option.name]: Option,
     	 flatPicker,
     	 VueBootstrapTypeahead
  
    },
    data() {
      return {
      	 query: '',
      	 ssic_info_1:{
      	 	code:'',
      	 	title:'',
      	 	title_and_code:'',
      	 },
      	  ssic_info_2:{
      	 	code:'',
      	 	title:'',
      	 	title_and_code:'',
      	 },
      	 ssiccodes: [],
      
      	 search_ssic:{
      	 	term:'',
      	 
      	 },
      	 
      	 verified:1,
     	 people:[],
     	 activePersonIndex: 9999,
     	 displayPerson: 9999,
     	 showCompanyForm: true,
     	 company:[],
     	  new_message:{
      	 	message:'',
      	 },
      	 model:[],
      	 messages:[],
      	 documents:[],
      	 countries:[],
     	 selects: {
          countries: [
            {value: 'SG', label: 'Singapore'},
		   ],
		   gov_id_types: [
            {value: 1, label: 'National ID/ NRIC'},
            {value: 2, label: 'Passport'},
		   ],
		   citizenship: [
            {value: 1, label: 'Singapore Citizen'},
            {value: 2, label: 'Singapore PR'},
            {value: 3, label: 'Foreign Citizen'},
		   ],
		   yesno: [
            {value: 1, label: 'Yes'},
             {value: 0, label: 'No'},
		   ],
		  gender: [
            {value: 'm', label: 'Male'},
            {value: 'f', label: 'Female'},
		   ],
		  },
	
      };
    },
    
      watch: {
    // When the query value changes, fetch new results from
    // the API - in practice this action should be debounced
    query(newQuery) {
   		 if(this.selectedUser){
   			 console.log("selectedU:"+this.selectedUser.code);
    	}
    	this.search_ssic.term = newQuery;
    	let uri = this.$base_url+'/api/v1/c/search_ssic';
			 ApiService.post(uri, this.search_ssic).then(response => {
			 	this.ssiccodes = response.data.results;
			 })
    
    
    }
  },
  
  filters: {
    stringify(value) {
      return JSON.stringify(value, null, 2)
    }
  },
  
    methods: {
     resendVerifyEmail(index) {
          	swal.showLoading();
      	  	let uri = this.$base_url+'/api/v1/c/resend_verify_email'
         	ApiService.get(uri).then(response => {
         	  swal.fire({
						title: `Success`,
						text: 'Verification email resent. If you have not seen it, please check your spam or junk folder. ',
						buttonsStyling: false,
						confirmButtonClass: 'btn btn-success',
						icon: 'success'
				 });
         	
   
      	})

      },
     submitCreateMessage() {
			if(!this.new_message.message){
				swal.fire({
								title: `Oops`,
								text: "Please enter a message before sending.",
								buttonsStyling: false,
								confirmButtonClass: 'btn btn-warning',
								icon: 'warning'
							  })
		
			}else{
				 swal.showLoading();
				 let uri = this.$base_url+'/api/v1/c/create_message';
				 ApiService.post(uri, this.new_message).then(response => {
					this.loadRequestPage();
					 swal.close();
   
				})
			}

      },
       uploadFile(){
      		if(!this.$refs.new_file.files[0]){
      			swal.fire({
							title: `Oops`,
							text: "Please select a file before uploading.",
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
      	
     	 	}else{
     	 		swal.showLoading();
      			let uploaded_file = this.$refs.new_file.files[0];
      			let formData = new FormData();
  			    formData.append('file', uploaded_file);
  			    
  			     let uri = this.$base_url+'/api/v1/c/upload_req_doc/'+ this.model.id;
				 ApiService.post(uri,formData).then(response => {
						this.loadRequestPage();
						swal.close();
			
				  })
			}
      
      },
      
       loadRequestPage(){

		
		
			let uri = this.$base_url+'/api/v1/c/get_request/'+ this.model.id;
			 ApiService.get(uri).then(response => {
			
				 const vm = this;
				 this.model = response.data.request;
				 this.new_message.eid = this.model.entity_id;
				 this.new_message.rid = this.model.id;
			 
				 this.messages = response.data.messages;
				 this.documents = response.data.documents;
		
			})

      
      },
      
      toggleCompanyForm(){
      
      	if(this.showCompanyForm == true){
      		this.showCompanyForm = false;
      	}
      	else if(this.showCompanyForm == false){
      		this.showCompanyForm = true;
      	}
      
      },
      displayPersonForm(index) {
			if(this.displayPerson == index){
				this.displayPerson = 9999;
			}
			else{
				this.displayPerson = index;
			}
			this.activePersonIndex = index;
		
      },
      confirmCompletion(){
      		
      		let status = true;
      		if(this.company.completion_status!=4){
      			status = false;
      			
      		}
      		
      		let people_arr = this.people;
      		
      		
      		for (var index = 0; index < people_arr.length; ++index) {
 				if(people_arr[index]['completion_status'] !=4){
 					status = false;
 				}
			}
      		
      		
      		if(status == false){
      			swal.fire({
							title: `Oops`,
							text: "You have not completed filling all details. Please check again.",
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
			}
			else{	
				swal.showLoading();
				const vm = this;
				let uri = this.$base_url+'/api/v1/c/onboarding/confirm_all_details';
				 ApiService.post(uri, this.company).then(response => {
					  vm.company = response.data.company;
					  
					  swal.fire({
						title: `Success`,
						text: 'Your company secretary is now processing your details and documents.',
						buttonsStyling: false,
						confirmButtonClass: 'btn btn-success',
						icon: 'success'
					  });
					 
										 
					 
					 swal.close();
   
				})//end api call
			
			}
      
      },
      async confirmCompany(){
      		this.company.activity_1_code = this.ssic_info_1.code;
      		this.company.activity_1_title = this.ssic_info_1.title;
      		this.company.activity_2_code = this.ssic_info_2.code;
      		this.company.activity_2_title = this.ssic_info_2.title;
      		
      		
      		swal.showLoading();
	      	let uri = this.$base_url+'/api/v1/c/onboarding/confirm_company';
    	     ApiService.post(uri, this.company).then(response => {
				 this.company.completion_status = response.data.company.completion_status;
	
     	 		 this.showCompanyForm = false;
				 swal.close();
   
      		})//end api call
      
      },
      async confirmPerson(){
      		let person = this.people[this.activePersonIndex];
      		swal.showLoading();
	      	let uri = this.$base_url+'/api/v1/c/onboarding/confirm_person';
    	     ApiService.post(uri, person).then(response => {
				 this.people[this.activePersonIndex].completion_status = response.data.person.completion_status;
				 this.activePersonIndex = 9999,
     	 		 this.displayPerson = 9999,
     	 
				 swal.close();
   
      		})//end api call
      },
    },
    mounted() {
      	swal.showLoading();
        const client_info = JSON.parse(TokenService.getUserInfo());
      	let uri = this.$base_url+'/api/v1/c/onboarding/incorp';
         ApiService.get(uri).then(response => {
         	
      		 const vm = this;
      		 this.people = response.data.people;
      		 this.company = response.data.company;
      		 
      		 this.ssic_info_1.code = this.company.activity_1_code;
      		 this.ssic_info_1.title = this.company.activity_1_title;
      		 this.ssic_info_2.code = this.company.activity_2_code;
      		 this.ssic_info_2.title = this.company.activity_2_title;
      		 
      		  this.verified = response.data.verified;
      		 
      		 if(this.company.completion_status==4){
      		 	this.showCompanyForm = false;
      		 }
      		 
      		 this.countries = response.data.countries;
      		 
      		// this.company.sources_arr = response.data.sources_arr;
      		 
      		 this.model = response.data.cr;
   			 this.new_message.eid = this.model.entity_id;
   			 this.new_message.rid = this.model.id;
   			 this.main_document_id = response.data.main_document;
   			 
   			 this.messages = response.data.messages;
   			 this.documents = response.data.documents;
      		 
      		 swal.close();
   
      	})
      	
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}



</style>














